/* tslint:disable */
/* eslint-disable */
/**
 * grpc/knowledge/space.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { KnowledgeCreateSpaceRequest } from '../models'
// @ts-ignore
import type { KnowledgeListSpacesResponse } from '../models'
// @ts-ignore
import type { KnowledgeSpaceResponse } from '../models'
// @ts-ignore
import type { RpcStatus } from '../models'
// @ts-ignore
import type { SpaceServiceUpdateSpaceBody } from '../models'
/**
 * SpaceServiceApi - axios parameter creator
 */
export const SpaceServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Creates a space. The key is what URLs and search filters carry, and it cannot be taken by two spaces at once.
     * @param {KnowledgeCreateSpaceRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spaceServiceCreateSpace: async (
      body: KnowledgeCreateSpaceRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('spaceServiceCreateSpace', 'body', body)
      const localVarPath = `/api/v1/knowledge/spaces`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Deletes a space together with its pages. Soft: the rows stay, filtered out everywhere, because a knowledge base is exactly where an accidental delete hurts most.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spaceServiceDeleteSpace: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('spaceServiceDeleteSpace', 'id', id)
      const localVarPath = `/api/v1/knowledge/spaces/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns one space, by id or by key.
     * @param {string} id Either the uuid or the key — people paste both, and refusing one of them buys nothing.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spaceServiceGetSpace: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('spaceServiceGetSpace', 'id', id)
      const localVarPath = `/api/v1/knowledge/spaces/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists spaces with their page counts.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [query] Substring of key or name. Not full-text: a dozen spaces do not need an index, and prefix matching is what people expect from a picker.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spaceServiceListSpaces: async (
      paginationPage?: string,
      paginationPerPage?: string,
      query?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/knowledge/spaces`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      if (query !== undefined) {
        localVarQueryParameter['query'] = query
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Changes a space. Fields left out keep their current values. The key is not among them: links already written down would stop resolving.
     * @param {string} id
     * @param {SpaceServiceUpdateSpaceBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spaceServiceUpdateSpace: async (
      id: string,
      body: SpaceServiceUpdateSpaceBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('spaceServiceUpdateSpace', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('spaceServiceUpdateSpace', 'body', body)
      const localVarPath = `/api/v1/knowledge/spaces/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * SpaceServiceApi - functional programming interface
 */
export const SpaceServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SpaceServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Creates a space. The key is what URLs and search filters carry, and it cannot be taken by two spaces at once.
     * @param {KnowledgeCreateSpaceRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spaceServiceCreateSpace(
      body: KnowledgeCreateSpaceRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeSpaceResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spaceServiceCreateSpace(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SpaceServiceApi.spaceServiceCreateSpace']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Deletes a space together with its pages. Soft: the rows stay, filtered out everywhere, because a knowledge base is exactly where an accidental delete hurts most.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spaceServiceDeleteSpace(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spaceServiceDeleteSpace(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SpaceServiceApi.spaceServiceDeleteSpace']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns one space, by id or by key.
     * @param {string} id Either the uuid or the key — people paste both, and refusing one of them buys nothing.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spaceServiceGetSpace(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeSpaceResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spaceServiceGetSpace(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SpaceServiceApi.spaceServiceGetSpace']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists spaces with their page counts.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [query] Substring of key or name. Not full-text: a dozen spaces do not need an index, and prefix matching is what people expect from a picker.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spaceServiceListSpaces(
      paginationPage?: string,
      paginationPerPage?: string,
      query?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeListSpacesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spaceServiceListSpaces(
        paginationPage,
        paginationPerPage,
        query,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SpaceServiceApi.spaceServiceListSpaces']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Changes a space. Fields left out keep their current values. The key is not among them: links already written down would stop resolving.
     * @param {string} id
     * @param {SpaceServiceUpdateSpaceBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spaceServiceUpdateSpace(
      id: string,
      body: SpaceServiceUpdateSpaceBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeSpaceResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spaceServiceUpdateSpace(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SpaceServiceApi.spaceServiceUpdateSpace']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * SpaceServiceApi - factory interface
 */
export const SpaceServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = SpaceServiceApiFp(configuration)
  return {
    /**
     *
     * @summary Creates a space. The key is what URLs and search filters carry, and it cannot be taken by two spaces at once.
     * @param {KnowledgeCreateSpaceRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spaceServiceCreateSpace(
      body: KnowledgeCreateSpaceRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<KnowledgeSpaceResponse> {
      return localVarFp
        .spaceServiceCreateSpace(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Deletes a space together with its pages. Soft: the rows stay, filtered out everywhere, because a knowledge base is exactly where an accidental delete hurts most.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spaceServiceDeleteSpace(id: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
      return localVarFp
        .spaceServiceDeleteSpace(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns one space, by id or by key.
     * @param {string} id Either the uuid or the key — people paste both, and refusing one of them buys nothing.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spaceServiceGetSpace(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<KnowledgeSpaceResponse> {
      return localVarFp
        .spaceServiceGetSpace(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists spaces with their page counts.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [query] Substring of key or name. Not full-text: a dozen spaces do not need an index, and prefix matching is what people expect from a picker.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spaceServiceListSpaces(
      paginationPage?: string,
      paginationPerPage?: string,
      query?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<KnowledgeListSpacesResponse> {
      return localVarFp
        .spaceServiceListSpaces(paginationPage, paginationPerPage, query, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Changes a space. Fields left out keep their current values. The key is not among them: links already written down would stop resolving.
     * @param {string} id
     * @param {SpaceServiceUpdateSpaceBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spaceServiceUpdateSpace(
      id: string,
      body: SpaceServiceUpdateSpaceBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<KnowledgeSpaceResponse> {
      return localVarFp
        .spaceServiceUpdateSpace(id, body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * SpaceServiceApi - object-oriented interface
 */
export class SpaceServiceApi extends BaseAPI {
  /**
   *
   * @summary Creates a space. The key is what URLs and search filters carry, and it cannot be taken by two spaces at once.
   * @param {KnowledgeCreateSpaceRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public spaceServiceCreateSpace(
    body: KnowledgeCreateSpaceRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SpaceServiceApiFp(this.configuration)
      .spaceServiceCreateSpace(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Deletes a space together with its pages. Soft: the rows stay, filtered out everywhere, because a knowledge base is exactly where an accidental delete hurts most.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public spaceServiceDeleteSpace(id: string, options?: RawAxiosRequestConfig) {
    return SpaceServiceApiFp(this.configuration)
      .spaceServiceDeleteSpace(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns one space, by id or by key.
   * @param {string} id Either the uuid or the key — people paste both, and refusing one of them buys nothing.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public spaceServiceGetSpace(id: string, options?: RawAxiosRequestConfig) {
    return SpaceServiceApiFp(this.configuration)
      .spaceServiceGetSpace(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists spaces with their page counts.
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {string} [query] Substring of key or name. Not full-text: a dozen spaces do not need an index, and prefix matching is what people expect from a picker.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public spaceServiceListSpaces(
    paginationPage?: string,
    paginationPerPage?: string,
    query?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return SpaceServiceApiFp(this.configuration)
      .spaceServiceListSpaces(paginationPage, paginationPerPage, query, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Changes a space. Fields left out keep their current values. The key is not among them: links already written down would stop resolving.
   * @param {string} id
   * @param {SpaceServiceUpdateSpaceBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public spaceServiceUpdateSpace(
    id: string,
    body: SpaceServiceUpdateSpaceBody,
    options?: RawAxiosRequestConfig,
  ) {
    return SpaceServiceApiFp(this.configuration)
      .spaceServiceUpdateSpace(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
